import filtersDevice from '@/constants/components/filters/filtersDevice';

export function convertJSONFiltersToArrayFilters(json: { [key: string]: string }) {
  return Object.keys(json).map((key: string) => ({
    id: key,
    values: json[key]
  }));
}

export function addFilter(filter: { id: string, values: string[] | string }, to?: any) {
  to.push({
    id: filter.id,
    translateKey: filtersDevice.find(initFilter => initFilter.id === filter.id)?.translateKey || '',
    active: true,
    options: filtersDevice.find(initFilter => initFilter.id === filter.id)?.options || [],
    values: filter.values,
    isOpen: false,
    displaySearchBar: true,
    inputType: filtersDevice.find(initFilter => initFilter.id === filter.id)?.inputType || ''
  });
  return to;
}

export function filterToValue(filterToConvert: any) {
  const functional: { [key: string]: (f: any) => any } = {
    'string': filter => String(filter.values),
    'number': filter => Number(filter.values),
    'date': filter => Number(filter.values),
    'number[]': filter => [Number(filter.values)],
    'multi_string': filter => filter.values,
    'multi_number': filter => filter.values.map((value: string) => Number(value))
  };
  let filterValue;
  if (filterToConvert.inputType && filterToConvert.inputType in functional) {
    filterValue = functional[filterToConvert.inputType](filterToConvert);
  }
  if (filterToConvert.id === 'countries' && filterToConvert.initialOptions) {
    filterValue = filterToConvert.initialOptions.filter((country: { name: string, iso: string }) => filterToConvert.values.includes(country.name)).map((country: { name: string, iso: string }) => country.iso);
  }
  return filterValue;
}

export function filterBuilder(selectedFilters: any) {
  const filters: { [key: string]: any } = {};
  selectedFilters.forEach((filter: any) => {
    const filterValue = filterToValue(filter);
    if (filterValue) {
      filter.active = true;
      filters[filter.id] = filterValue;
    }
  });
  return filters;
}

export function configToFilter(config: any) {
  const arrFilters = convertJSONFiltersToArrayFilters(JSON.parse(config));
  let filters: any = [];
  arrFilters.forEach((filter) => {
    filters = addFilter(filter, filters);
  });
  return filterBuilder(filters);
}
